import React, { useEffect } from 'react';

const Modal = ({ show, message, onClose }) => {
    useEffect(() => {
        if (show) {
            const timer = setTimeout(() => onClose(), 3000);
            return () => clearTimeout(timer);
        }
    }, [show, onClose]);

    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[1000]">
            <div className="bg-white p-5 rounded-xl shadow-lg w-[90%] max-w-md sm:max-w-sm">
                <div className="text-center mb-5">{message}</div>
                <div className="text-center">
                    <button
                        onClick={onClose}
                        className="w-full py-2 px-4 text-primary border-2 border-primary rounded-md hover:bg-primary hover:text-white transition"
                    >
                        Закрыть
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal;